export default __webpack_public_path__ + "static/media/0.52.cca41966.jpg";